import { combineReducers } from 'redux'

import usersReducer from './user/usersReducer'
import uiReducer from './uiReducer'
import clientsReducer from './client/clientReducer'
import tasksReducer from './task/taskReducer'
import taskDropdownListsReducer from './task/taskDropdownListsReducer'
import editTaskReducer from './task/editTaskReducer'
import inventoryReducer from './reports/inventoryReducer'
import outBoundReducer from './reports/outBoundReportsReducers';
const rootReducer = combineReducers({
  users: usersReducer,
  uiActions: uiReducer,
  clients: clientsReducer,
  tasks: tasksReducer,
  taskDropdownLists: taskDropdownListsReducer,
  inventory: inventoryReducer,
  editTask: editTaskReducer,
  outBound: outBoundReducer
})

export default rootReducer